import React, { useState, useEffect, useContext } from "react";
import { PopoverPicker } from "./PopoverPicker";
import "./styles.css";

export default function Slecetor({ color, handleChangeColor, type }) {

  const setColors = (value) => {
    handleChangeColor(type, value)
  }

  return <PopoverPicker color={color} onChange={setColors} />;
};
